const results = {

	elem: {
		$results: $('.results'),
		$keywords: $('.keyword'),
		$checkboxes: $('.filters__item--checkboxes'),
		$radios: $('.filters__item--radios'),
		$selects: $('.filters__item--selects'),
		$loading: $('.results__loading'),
		$chips: $('.results__chips'),
		$reset: $('.results__reset'),
		$count: $('.results__count'),
		$items: $('.results__items'),
		$pagination: $('.results__pagination')
	},
	
	dataSource: null,
	filters: {},
	initial: true,
	results: '',
	suggestions: '',
	
	// initialize the search aggregate
	init() {
		this.dataSource = this.elem.$results.data('src');
		this.buildFilters();
		this.getQuery();
		this.setControls();
		this.buildChips();
		this.setQuery(false, false);
		window.onpopstate = this.filterState;
		this.elem.$reset.on('click', this.filterReset);
	},

	// rebind functions to filters after successfully updating the state
	bindUIActions() {
		this.elem.$checkboxes.find('input[type="checkbox"]').on('change', this.filterCheckbox);
		this.elem.$keywords.find('button').on('click', this.filterKeyword);
		this.elem.$keywords.find('input').on('keydown', this.filterKeyword);
		this.elem.$radios.find('input[type="radio"]').on('change', this.filterRadio);
		this.elem.$selects.find('select').on('change', this.filterSelect);
	},

	// unbind UI from the filters while in the process of updating the state
	unbindUIActions() {
		this.elem.$checkboxes.find('input[type="checkbox"]').off('change');
		this.elem.$keywords.find('button').off('click');
		this.elem.$keywords.find('input').off('keydown');
		this.elem.$radios.find('input[type="radio"]').off('change');
		this.elem.$selects.find('select').off('change', this.filterSelect);
	},

	// add a new chip to the list of chips and bind the unfilterChip action to it
	addChip(key, label) {
		let output = '<a href="#' + key + '" class="chip"><span class="chip__close"><span class="show-for-sr">Remove this filter</span><svg class="brei-icon brei-icon-close" focusable="false"><use href="#brei-icon-close"></use></svg></span><span class="chip__label">' + label + '</span></a>';
		results.elem.$chips.prepend(output);
		$('.chip[href="#' + key + '"]').on('click', results.unfilterChip);
	},

	// remove a chip from the list of chips
	removeChip(key) {
		$('.chip[href="#' + key + '"]').remove();
	},

	// update the state when a chip is clicked
	unfilterChip(e) {
		e.preventDefault();
		let target = e.currentTarget.hash;
		let value = target.substr(1);
		
		// if the filter is a checkbox, click it (which will unselect it and trigger a refresh)
		if( $(target)[0].type === 'checkbox' ) {
			$(target).trigger('click');
		}

		// if the filter is a keyword search, zero its value and the pageindex, and update the query
		if(($(target)[0].type === 'search') || ($(target)[0].type === 'text')) {
			$(e.currentTarget).remove();
			$(target)[0].value = '';
			results.filters[value] = '';
			results.filters['pageindex'] = 0;
			results.setQuery(true, true);
		}

		// if the filter is a radio button
		if($(target)[0].type === 'radio') {
			$(e.currentTarget).remove();
			$(target).prop('checked', false);
			results.filters[$(target)[0].name] = '';
			results.filters['pageindex'] = 0;
			results.setQuery(true, true);
		}
		
		// if the filter is a selectbox, set the selectedIndex to -1 and trigger the change event
		if( $(target)[0].localName === 'select' ) {
			$(target)[0].selectedIndex = 0;
			$(target).siblings('.selectability').find('[role="textbox"]')[0].innerHTML = '';
			$(target).trigger('change').removeClass('js-selectability--has-value');
		}
	},

	// build chips from filter array
	buildChips() {
		for (let key in results.filters) {
			let keyid = '#' + key;
			let label = '';
			if (results.filters.hasOwnProperty(key)) {
				// if the filter is an array (checkbox) add an item for each item in the array
				if (Array.isArray(results.filters[key])) {
					if (results.filters[key].length > 0 ) {
						for (let i = 0; i < results.filters[key].length; i = i + 1) {
							let item = $('[id^="' + key + '"][value="' + results.filters[key][i] + '"]');
							label = item.siblings('label')[0].innerHTML;
							results.addChip(item.attr('id'), label);
						}
					}
				} else {
					// if the filter is not the pagindex or pagesize parameter
					if((key !== 'pageindex') && (key !== 'pagesize') && (results.filters[key] !== '')) {
						// If $(keyID)[0] is undefined this is a radio)
						if($(keyid)[0] === undefined) {
							let oldkey = key;
							key = $('[name="' + oldkey + '"][value="' + results.filters[oldkey] + '"]')[0].id;
							label = $('[name="' + oldkey + '"][value="' + results.filters[oldkey] + '"]').siblings('label')[0].innerText;
						} else {
							// if the filter is an input, set the label to the value
							if( $(keyid)[0].localName === 'input') {
								label = $(keyid)[0].value;
							}
							// if the filter is a label, set the label to the text of the selected option
							if( $(keyid)[0].localName === 'select') {
								label = $(keyid)[0].options[$(keyid)[0].selectedIndex].text;
							}
						}
						results.addChip(key, label);
					}
				}
			}
		}
	},

	// build the filter array from the elements on the page
	buildFilters() {
		if(results.elem.$keywords.length > 0) {
			results.filters['search'] = '';
		}
		//  for each group of checkboxes to the page, add an array with a name equal to the legend
		if(results.elem.$checkboxes.length > 0) {
			results.elem.$checkboxes.each(function() {
				results.filters[$(this).find('.checkbox-list')[0].dataset.label] = [];
			});
		}
		// for each keyword search (there should only be one) add a string with a name equal to the id
		if(results.elem.$keywords.length > 0) {
			results.elem.$keywords.each(function() {
				results.filters[$(this).find('input')[0].id] = '';
			});
		}
		// for each radios, add a string wiith a name equal to the id
		if(results.elem.$radios.length > 0) {
			results.elem.$radios.each(function() {
				results.filters[$(this).find('.radio-list')[0].dataset.label] = '';
			});
		}
		// for each selectbox, add a string wiith a name equal to the id
		if(results.elem.$selects.length > 0) {
			results.elem.$selects.find('select').each(function() {
				results.filters[this.id] = '';
			});
		}
		// set initial pageindex to 0 and initial pagesize to 10
		results.filters['pageindex'] = 0;
		results.filters['pagesize'] = 12;
	},

	// build a query string from the filters
	buildQuery() {
		let data = this.filters;
		let query = [];
		for (let key in data) {
			if (data.hasOwnProperty(key)) {
				if (Array.isArray(key)) {
					data[key] = key.toString();
				}
				query.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
			}
		}
		query = query.join('&').replace(/%2C/g, ',');
		return query;
	},

	// filtering on checkbox click
	filterCheckbox(e) {
		let id = e.currentTarget.id;
		let key = id.substring(0, e.currentTarget.id.indexOf('-'));
		let value = e.currentTarget.value;
		let label = $(e.currentTarget).siblings('label')[0].innerText;
		let status = e.currentTarget.checked;

		// if the checkbox is checked, add a chip and add it to the state
		if(status) {
			results.addChip(id, label);
			results.filters[key].push(value);
		// otherwise, remove the chp and splice it out of the state
		} else {
			results.removeChip(id);
			results.filters[key].splice(results.filters[key].indexOf(value),1);
		}
		results.filters['pageindex'] = 0; // reset the page index
		results.setQuery(true, true); // set the query
	},

	// filtering on keyword submit
	filterKeyword(e) {
		let filter = false;
		let key = '';

		// if the triggering event is a keydown inside the input, only trigger if there is a return
		/// set the key to the id of the input
		if ((e.type === 'keydown') && (e.keyCode === 13)) {
			key = $(e.currentTarget)[0].id;
			filter = true;
		}

		// if the triggering event is a click on the submit button
		// set the key to id of the adjacent input
		if (e.type === 'click') {
			key = $(e.currentTarget).siblings('input')[0].id;
			filter = true;
		}

		if (filter) {
			e.preventDefault();
			results.removeChip(key); 
			let value = '<span>' + $('#' + key)[0].value.trim() + '</span>';
			let safeValue = $(value).text();
			if(safeValue.length > 0) {
				results.addChip(key, safeValue);
				results.filters[key] = safeValue;
			} else {
				results.filters[key] = '';
			}
			results.filters['pageindex'] = 0;
			results.setQuery(true, true);
		}
	},

	// filtering on pagination click
	filterPagination(e) {
		e.preventDefault();
		results.filters['pageindex'] = e.currentTarget.hash.substr(1);
		results.setQuery(true, true);
	},

	// filtering on radio change
	filterRadio(e) {
		e.preventDefault();
		let id = e.currentTarget.id;		
		let key = e.currentTarget.name;
		let value = e.currentTarget.value;
		let label = $(e.currentTarget).siblings('label')[0].innerText;
		let status = e.currentTarget.checked;
		if(status) {
			let others = $('input[type="radio"][name="' + key + '"]');
			others.each(function() {
				let otherid = this.id;
				results.removeChip(otherid);
			});
			results.addChip(id, label);
			results.filters[key] = value;
		} else {
			results.removeChip(id);
			results.filters[key] = '';
		}
		results.filters['pagindex'] = 0;
		results.setQuery(true, true);
	},
	
	
	// reset all filters
	filterReset(e) {
		e.preventDefault();
		results.unbindUIActions();
		results.elem.$checkboxes.find('input').prop('checked',false);
		results.elem.$keywords.find('input').val('');
		if(results.elem.$selects.length > 0) {
			results.elem.$selects.find('select')[0].selectedIndex = 0;
			results.elem.$selects.find('select').siblings('.selectability').find('[role="textbox"]').html('Year');
			results.elem.$selects.find('select').removeClass('js-selectability--has-value');
		}
		$('.chip').remove();
		results.buildFilters();
		results.setQuery(true, true);
		results.bindUIActions();		
	},

	// filter on selectbox change
	filterSelect(e) {
		e.preventDefault();
		let key = e.currentTarget.id;
		let value = e.currentTarget.value;
		results.removeChip(key);
		if(e.currentTarget.selectedIndex > 0) {
			let label = e.currentTarget.options[e.currentTarget.selectedIndex].text;
			$(e.currentTarget).siblings('.selectability').find('[role="textbox"]')[0].innerHTML = label;
			results.addChip(key, label);
		}
		results.filters[key] = value;
		results.filters['pageindex'] = 0;
		results.setQuery(true, true);
	},

	// filtering on history state change
	filterState() {
		results.getQuery();
		results.setControls();
		results.setQuery(false, false);
	},

	// get data
	getData(query) {
		let deferred = $.Deferred();
		$.ajax({
			url: results.dataSource,
			method: 'GET',
			data: query,
			dataType: 'html',
			success: function(data) {
				deferred.resolve(data);
			},
			error: function(jqXHR, textStatus, errorThrow) {
				console.log(jqXHR, errorThrow);
				deferred.reject(textStatus);
			}
		});
		return deferred.promise();
	},
	
	// overwrite default filter settings with values passed through query string, ignoring blank values and values without a filter
	getQuery() {
		if (window.location.search.length > 0) { 
			let searchParams = new URLSearchParams(window.location.search);
			searchParams.forEach(function (value,key) {
				if(value !== '') {
					if(results.filters[key] !== undefined) {					
						if (Array.isArray(results.filters[key])) {
							results.filters[key] = [];
							value = value.split(',');
							results.filters[key] = value;
						} else {
							results.filters[key] = value;
						}
					}
				}
			});
		}
	},

	// build and render count from retrieved results
	renderCount() {
		let output = parseInt(results.filters['pageindex']) * parseInt(results.filters['pagesize']) + 1;
		let maxCount = output + parseInt(results.filters['pagesize']) - 1;
		if (maxCount > results.results.TotalCount) {
			maxCount = results.results.TotalCount;
		}
		if (parseInt(maxCount) !== 1) {
			output += ' to ';
			output += maxCount;
			output += ' of ';
			output += results.results.TotalCount;
		} else {
			output += ' Result';
		}
		results.elem.$count.html(output);
	},

	// build and render pagination from retrieved results
	renderPagination() {
		let items = [];
		let filters = results.filters;
		let current = parseInt(filters['pageindex']);
		let max = Math.ceil(parseInt(results.results.TotalCount) / parseInt(filters['pagesize'])) - 1;
		let output = '<ul class="pagination__list" aria-label="Pagination">';

		// push all the items we need at a minimum: first, current, last, and output bracketing current
		items.push(0, current - 1, current, current + 1, max);

		// when the values are close to first or last, push some extra options to ensure that we always have at least four options showing
		if (current < 2) {
			items.push(2);
		}
		if (current > (max - 1)) {
			items.push(max - 2);
		}
		
		// filter out results that are less than zero
		// filter out results that are greater than max
		// filter out non-unique items
		// sort
		items = items.filter(function(x){ return x > -1 });
		items = items.filter(function(x){ return x <= max });
		items = [...new Set(items)];
		items = items.sort(function(a, b){return a-b});

		// previous button
		output += '<li class="pagination__item pagination__item--prev"><a href="#' + (current - 1) + '" class="pagination__button icon-btn icon-btn--no-circle';
		if(current === 0) {
			output += ' icon-btn--disabled" tabindex="-1';
		}
		output += '" rel="prev"><svg class="brei-icon brei-icon-chevron-s" focusable="false"><use href="#brei-icon-chevron-s"></use></svg><span class="show-for-sr">Previous Page</span></a></li>';

		// individual results
		for(let i = 0; i < items.length; i = i + 1) {
			if((i === 0) || (items[i] !== items[i - 1])) {
				if((i > 0) && ((items[i] - items[i - 1]) > 1)) {
					output += '<li class="pagination__item"><span class="pagination__span">...</span></li>';
				}
				if(items[i] === current) {
					output += '<li class="pagination__item pagination__item--active"><a href="#' + items[i] + '" class="pagination__link" tabindex="-1"><span class="show-for-sr">You\'re on page</span> ' + (items[i] + 1) + '</a></li>';
				} else {
					output += '<li class="pagination__item"><a href="#' + items[i] + '" class="pagination__link" aria-label="Page ' + (items[i] + 1) + '">' + (items[i] + 1) + '</a></li>';
				}
			}
		}

		// next button
		output += '<li class="pagination__item pagination__item--next"><a href="#' + (current + 1) + '" class="pagination__button icon-btn icon-btn--no-circle';
		if(current === max) {
			output += ' icon-btn--disabled" tabindex="-1';
		}
		output += '" rel="next"><svg class="brei-icon brei-icon-chevron-s" focusable="false"><use href="#brei-icon-chevron-s"></use></svg><span class="show-for-sr">Next Page</span></a></li></ul>';
		
		results.elem.$pagination.html(output);
		$('.pagination__button, .pagination__link').on('click', results.filterPagination); // rebind UI actions
	},

	// build and render retrieved results 
	renderResults() {

		// hide the loading animation
		results.elem.$loading.hide();

		// if this is not the initial set-up of the aggregate, zero out any featured results on the page
		if(results.initial === false) {
			if(($('.results__chips').children().length === 0) && (parseInt(results.filters['pageindex']) === 0)) {
				$('.results__feature').show();
			} else {
				$('.results__feature').hide();
			}
		}

		// if there are results, render the count, results, and pagination then fade them in
		if(results.results.TotalCount > 0) {
			results.filters['pagesize'] = parseInt(results.results.PageSize); // reset pagesize based on response
			results.renderCount();
			results.elem.$count.fadeIn();
			results.elem.$items.html(results.results.Results).fadeIn();
			if(results.results.TotalCount > results.filters['pagesize']) {
				results.renderPagination();
				results.elem.$pagination.fadeIn();
			}
		} else {
			results.elem.$items.html('<p class="results__none">No matching results were found.</p>').fadeIn();	
		}

		// set the state of the machine so we know to zero the featured results next time
		results.initial = false;
	},

	// update filters elements based on filters
	setControls() {
		// unbind all UI actions
		results.unbindUIActions();

		// uncheck every checkbox
		results.elem.$checkboxes.find('input').prop('checked',false);
		
		for (let key in results.filters) {
			// if the filter is an array (i.e. a checkbox) loop through the array and check every checkbox in it
			if (results.filters.hasOwnProperty(key)) {
				if (Array.isArray(results.filters[key])) {
					for (let i = 0; i < results.filters[key].length; i = i + 1) {
						let item = $('[id^="' + key + '"][value="' + results.filters[key][i] + '"]');
						item.prop('checked',true);
					}
				} 
				else {
					// if the filter is not an array, or the pageindex or pagesize parameters
					if((key !== 'pageindex') && (key !== 'pagesize') && (results.filters[key] !== '')) {
						let keyid = '#' + key;
						// If $(keyID)[0] is undefined this is a radio)
						if($(keyid)[0] === undefined) {
							let item = $('[name="' + key + '"][value="' + results.filters[key] + '"]');
							item.prop('checked',true);
						} else {
							// if the filter is a keyword search (input box) set its value]
							if( $(keyid)[0].localName === 'input' ) {
								$(keyid)[0].value = results.filters[key];
							}
							// if the filter is a selectbox, update its value and trigger the change event for selectability
							if( $(keyid)[0].localName === 'select' ) {
								$(keyid).val(results.filters[key]).trigger('change').addClass('js-selectability--has-value');
							}
						}
					}

				}
			}
		}
		
		// rebind UI actions
		results.bindUIActions();
	},

	// update queryString based on filters
	setQuery(reposition, push) {
		// build the request to the datasource
		
		let query = results.buildQuery();
		let dataObj = results.getData(query);

		// if reposition is true, scroll to the top of the results
		if (reposition === true) {
			$('html, body').animate({ scrollTop: $('.results').offset().top }, 425);
		}

		// if push is true, add the new page state to the browser history; otherwise, just replace the page state
		if (push === true) {
			history.pushState(null, '', '?' + query);
		} else {
			history.replaceState(null, '', '?' + query);
		}
		
		// show the "loading" animation, then fade out and empty all other page elements
		results.elem.$loading.show();
		results.elem.$count.fadeOut().empty();
		results.elem.$items.fadeOut().empty();
		results.elem.$pagination.fadeOut().empty();

		// send a request to the data source; when it is finished render the results
		$.when(dataObj)
			.done(function(data) {
				setTimeout(function() {
					results.results = JSON.parse(data);
					results.renderResults();
				}, 500);
			})
			.fail(function () {
				console.log('API ERROR: No results were returned')
			});
	}

};

export {results};
